
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/announcement",
      function () {
        return require("private-next-pages/v2/announcement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/announcement"])
      });
    }
  